module.exports = __webpack_public_path__ + "7b5c854b62d38e59a5133ce8ccaa5e7c.svg";